import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { PasswordModule } from 'primeng/password';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { DirectiveModule } from '@Directive/directive.module';

import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { SettingsFormComponent } from './settings-form/settings-form.component';
import { NumDisplayerComponent } from './num-displayer/num-displayer.component';
import { ResultsKpiComponent } from './results-kpi/results-kpi.component';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { OrganizationCreationFormComponent } from './organization-creation-form/organization-creation-form.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DedicatedAdminOrganisationListComponent } from '../../dedicated_admin/home/dedicated-admin-organisation-list/dedicated-admin-organisation-list.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { AccordionModule } from 'primeng/accordion';
import { MultiSelectModule } from 'primeng/multiselect';
import { SkeletonModule } from 'primeng/skeleton';
import { KnobModule } from 'primeng/knob';

import { DedidcatedAdminFormComponent } from './dedidcated-admin-form/dedidcated-admin-form.component';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { SettingsFormPeriodComponent } from './settings-form/settings-form-period/settings-form-period.component';
import { SettingsFormOrganizationComponent } from './settings-form/settings-form-organization/settings-form-organization.component';
import { SettingsFormUserComponent } from './settings-form/settings-form-user/settings-form-user.component';
import { EditPeriodComponent } from './settings-form/settings-form-period/edit-period/edit-period.component';
import { ImageSelectorComponent } from './image-selector/image-selector.component';
import { SelectMeasureComponent } from './select-measure/select-measure.component';
import { SettingsFormEntitiesComponent } from './settings-form/settings-form-entities/settings-form-entities.component';
import { EditEntityComponent } from './settings-form/settings-form-entities/edit-entity/edit-entity.component';
import { FreetrialExpirationComponent } from './freetrial-expiration/freetrial-expiration.component';
import { CommonPageComponent } from './questionnaire-sections/common-page/common-page.component';
import { MobilityPageComponent } from './questionnaire-sections/mobility-page/mobility-page.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { QuestionComponent } from '../measure/question/question.component';
import { QuestionInstanceComponent } from '../measure/question/question-instance/question-instance.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabsModule } from 'primeng/tabs';
import { SettingsFormUsersManagmentComponent } from './settings-form/settings-form-users-managment/settings-form-users-managment.component';
import { EditUserComponent } from './settings-form/settings-form-users-managment/edit-user/edit-user.component';

import { TranslatePluralPipe } from '../../pipes/translate-plural.pipe';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { StepsModule } from 'primeng/steps';
import { TermsComponent } from './terms/terms.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SettingsFormTagComponent } from './settings-form/settings-form-tag/settings-form-tag.component';
import { EditTagComponent } from './settings-form/settings-form-tag/edit-tag/edit-tag.component';
import { DatePickerModule } from 'primeng/datepicker';
import { PageFooterModule } from './footer/footer.module';
import { HeaderComponent } from './header/header.component';
import { TruncateWithTooltipComponent } from './truncate-with-tooltip/truncate-with-tooltip.component';
import { SettingsFormAnalyticCategoriesComponent } from './settings-form/settings-form-analytic-categories/settings-form-analytic-categories.component';
import { EditAnalyticCategoryComponent } from './settings-form/settings-form-analytic-categories/edit-analytic-category/edit-analytic-category.component';
import { PaginatedKpiComponent } from './paginated-kpi/paginated-kpi.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { ChipModule } from 'primeng/chip';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { FluidModule } from 'primeng/fluid';
import { MessageModule } from 'primeng/message';
import { TagModule } from 'primeng/tag';
import { MoveCopyModalComponent } from './move-copy-modal/move-copy-modal.component';
import { BulkUpdateModalComponent } from './bulk-update-modal/bulk-update-modal.component';
import { DatabaseCardComponent } from './database-card/database-card.component';
import { ReduceStepsComponent } from './reduce-steps/reduce-steps.component';
import { StepNavComponent } from './step-nav/step-nav.component';
import { DimensionResponsibleSelectionComponent } from './dimension-responsible-selection/dimension-responsible-selection.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { KpiDenominatorMatrixComponent } from './kpi-denominator-matrix/kpi-denominator-matrix.component';
import { KpiTypeAddFormComponent } from './kpi-type-add-form/kpi-type-add-form.component';

@NgModule({
    declarations: [
        ReduceStepsComponent,
        LanguageSelectorComponent,
        LoadingScreenComponent,
        NumDisplayerComponent,
        ResultsKpiComponent,
        SettingsFormComponent,
        OrganizationCreationFormComponent,
        DedicatedAdminOrganisationListComponent,
        DedidcatedAdminFormComponent,
        SearchbarComponent,
        SettingsFormOrganizationComponent,
        SettingsFormUserComponent,
        SettingsFormPeriodComponent,
        TranslatePluralPipe,
        EditPeriodComponent,
        ImageSelectorComponent,
        SelectMeasureComponent,
        SettingsFormEntitiesComponent,
        EditEntityComponent,
        CommonPageComponent,
        MobilityPageComponent,
        QuestionComponent,
        QuestionInstanceComponent,
        FreetrialExpirationComponent,
        SettingsFormUsersManagmentComponent,
        EditUserComponent,
        OnboardingComponent,
        TermsComponent,
        SettingsFormTagComponent,
        EditTagComponent,
        HeaderComponent,
        TruncateWithTooltipComponent,
        SettingsFormAnalyticCategoriesComponent,
        EditAnalyticCategoryComponent,
        MoveCopyModalComponent,
        BulkUpdateModalComponent,
        DimensionResponsibleSelectionComponent,
        PaginatedKpiComponent,
        DatabaseCardComponent,
        FileUploadComponent,
        KpiDenominatorMatrixComponent,
        KpiTypeAddFormComponent,
    ],
    imports: [
        FluidModule,
        InputGroupAddonModule,
        InputGroupModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        DirectiveModule,
        PageFooterModule,
        StepNavComponent,
        // PrimeNG Modules
        AutoCompleteModule,
        DatePickerModule,
        ConfirmDialogModule,
        ButtonModule,
        DialogModule,
        SelectModule,
        InputMaskModule,
        InputNumberModule,
        InputTextModule,
        InputIconModule,
        IconFieldModule,
        TextareaModule,
        PasswordModule,
        ScrollPanelModule,
        TooltipModule,
        TableModule,
        TreeTableModule,
        TreeSelectModule,
        TabsModule,
        AccordionModule,
        AvatarModule,
        AvatarGroupModule,
        BadgeModule,
        RadioButtonModule,
        MultiSelectModule,
        StepsModule,
        CheckboxModule,
        ProgressSpinnerModule,
        SkeletonModule,
        KnobModule,
        ChipModule,
        MessageModule,
        TagModule,
    ],
    exports: [
        ReduceStepsComponent,
        DedidcatedAdminFormComponent,
        DedicatedAdminOrganisationListComponent,
        FreetrialExpirationComponent,
        OrganizationCreationFormComponent,
        LanguageSelectorComponent,
        LoadingScreenComponent,
        NumDisplayerComponent,
        ResultsKpiComponent,
        SettingsFormComponent,
        SearchbarComponent,
        SelectMeasureComponent,
        TranslatePluralPipe,
        ImageSelectorComponent,
        PageFooterModule,
        HeaderComponent,
        TruncateWithTooltipComponent,
        PaginatedKpiComponent,
        DatabaseCardComponent,
        FileUploadComponent,
        KpiDenominatorMatrixComponent,
        KpiTypeAddFormComponent,
    ],
})
export class ComponentsModule {}
